import React from "react";
import PropTypes from 'prop-types';

import style from "./TeamIcons.css";

const TeamIcon = ({ team }) => {
  return (
    <div className={style.icon}>
      <div className={style.swatch}
        style={{ backgroundColor: team.color }}>
        <img src={team.image} />
      </div>
    </div>
  );
};

TeamIcon.propTypes = {
  team: PropTypes.object.isRequired
};

export default TeamIcon;



// WEBPACK FOOTER //
// ./component/TeamIcons/TeamIcon.js